<template>
  <div class="review-wrapper">
    <h3>Step 1 of 3: Account Type</h3>
    <dl>
      <div>
        <dt>Account type</dt>
        <dd>{{ accountType.display }}</dd>
      </div>
    </dl>
    <h3>Step 2 of 3: {{ accountType.display }} Particulars</h3>
    <dl v-if="Object.values(corporateForm).length && accountType === accountTypes.CORPORATE">
      <div v-if="corporateForm.internalRef">
        <dt>Your Internal Reference</dt>
        <dd>{{ corporateForm.internalRef }}</dd>
      </div>
      <div v-if="corporateForm.email">
        <dt>Email Address</dt>
        <dd>{{ corporateForm.email }}</dd>
      </div>
      <div v-if="corporateForm.phone">
        <dt>Contact Number (Office)</dt>
        <dd>{{ corporateForm.phone }}</dd>
      </div>
      <h4>Registration</h4>
      <div v-if="corporateForm.registration.nameRegistered">
        <dt>Registered Name</dt>
        <dd>{{ corporateForm.registration.nameRegistered }}</dd>
      </div>
      <div v-if="corporateForm.registration.tradeName">
        <dt>Trading Name</dt>
        <dd>{{ corporateForm.registration.tradeName }}</dd>
      </div>
      <!-- <div v-if="corporateForm.registration.licenseType">
          <dt>License Type</dt>
          <dd>{{ corporateForm.registration.licenseType }}</dd>
        </div> -->
      <div v-if="corporateForm.registration.licenseNum">
        <dt>Entity Number</dt>
        <dd>{{ corporateForm.registration.licenseNum }}</dd>
      </div>
      <div v-if="corporateForm.registration.incorporationDate">
        <dt>Date of Incorporation</dt>
        <dd>{{ corporateForm.registration.incorporationDate }}</dd>
      </div>
      <div v-if="corporateForm.registration.incorporationCountry && isBeneficiary">
        <dt>Country of Incorporation</dt>
        <dd>{{ corporateForm.registration.incorporationCountry.name }}</dd>
      </div>
      <div v-if="corporateForm.registration.businessNature && corporateForm.registration.businessNature.display">
        <dt>Business Nature</dt>
        <dd>{{ corporateForm.registration.businessNature.display }}</dd>
      </div>
      <h4 v-if="corporateForm.address.address || corporateForm.address.zip || corporateForm.address.city || corporateForm.address.country">Address</h4>
      <div v-if="corporateForm.address.address || corporateForm.address.zip || corporateForm.address.city || corporateForm.address.country">
        <dt>Address</dt>
        <dd v-if="corporateForm.address.address">{{ corporateForm.address.address }}</dd>
        <dd v-if="corporateForm.address.zip">{{ corporateForm.address.zip }}</dd>
        <dd v-if="corporateForm.address.city">{{ corporateForm.address.city }} {{ corporateForm.address.state ? ',' + corporateForm.address.state : '' }}</dd>
        <dd v-if="corporateForm.address.state">{{ corporateForm.state }}</dd>
        <dd v-if="corporateForm.address.country">{{ corporateForm.address.country.name }}</dd>
      </div>
    </dl>
    <dl v-else-if="Object.values(individualForm).length && accountType === accountTypes.INDIVIDUAL">
      <div>
        <dt>First Name</dt>
        <dd>{{ individualForm.firstName }}</dd>
      </div>
      <div>
        <dt>Last Name</dt>
        <dd>{{ individualForm.lastName }}</dd>
      </div>
      <div v-if="individualForm.referenceId">
        <dt>Your Internal Reference</dt>
        <dd>{{ individualForm.referenceId }}</dd>
      </div>
      <div v-if="individualForm.gender">
        <dt>Gender</dt>
        <dd class="capitalize">{{ individualForm.gender }}</dd>
      </div>
      <div v-if="individualForm.email">
        <dt>Email Address</dt>
        <dd>{{ individualForm.email }}</dd>
      </div>
      <div v-if="individualForm.phone">
        <dt>Contact number (Mobile)</dt>
        <dd>{{ individualForm.phone }}</dd>
      </div>
      <div v-if="individualForm.occupation && individualForm.occupation.val">
        <dt>Occupation</dt>
        <dd>{{ individualForm.occupation.display }}</dd>
      </div>
      <div v-if="individualForm.address || individualForm.city || individualForm.state || individualForm.zip || individualForm.residenceCountry">
        <dt>Address</dt>
        <dd v-if="individualForm.address">{{ individualForm.address }}</dd>
        <dd v-if="individualForm.city">{{ individualForm.city }}</dd>
        <dd v-if="individualForm.state">{{ individualForm.state }}</dd>
        <dd v-if="individualForm.zip">{{ individualForm.zip }}</dd>
        <dd v-if="individualForm.residenceCountry">{{ individualForm.residenceCountry.name }}</dd>
      </div>

      <h4 v-if="!isBeneficiary">Identification</h4>
      <div v-if="individualForm.nationality.name">
        <dt>Nationality</dt>
        <dd>{{ individualForm.nationality.name }}</dd>
      </div>
      <div v-if="individualForm.birthdate">
        <dt>Date of Birth</dt>
        <dd>{{ individualForm.birthdate }}</dd>
      </div>
      <div v-if="individualForm.idType">
        <dt>ID Type</dt>
        <dd>{{ individualForm.idType.display }}</dd>
      </div>
      <div v-if="individualForm.idNumber">
        <dt>ID Number</dt>
        <dd>{{ individualForm.idNumber }}</dd>
      </div>
      <div v-if="individualForm.idIssuingCountry.name">
        <dt>Issuing Country</dt>
        <dd>{{ individualForm.idIssuingCountry.name }}</dd>
      </div>
      <div v-if="individualForm.idIssueDate">
        <dt>Issue Date</dt>
        <dd>{{ individualForm.idIssueDate }}</dd>
      </div>
      <div v-if="individualForm.idExpDate">
        <dt>Expiry Date</dt>
        <dd>{{ individualForm.idExpDate }}</dd>
      </div>
    </dl>
  </div>
</template>

<script>
import { PAYOUT_ACCOUNT_TYPES } from '@/constants';
export default {
  name: 'FiatAccountReview',
  props: {
    isBeneficiary: {
      type: Boolean,
      required: true,
    },
    accountType: {
      type: Object,
      default: () => { },
    },
    account: {
      type: Object,
      default: () => { },
    },
    paymentDetails: {
      type: Object,
      default: () => { },
    },
    individualForm: {
      type: Object,
      default: () => { },
    },
    corporateForm: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      // Your data properties here
      accountTypes: PAYOUT_ACCOUNT_TYPES
    };
  },
  methods: {
    // Your methods here
  },
  mounted() {
    // Your mounted hook code here
  },
};
</script>

<style scoped lang="scss">
.review-wrapper {
  margin-top: $margin-m;

  h3 {
    color: $color-primary-light;
    font-weight: bold;
    font-size: 18px;
  }

  h4 {
    margin-top: $margin-l;
    margin-bottom: $margin-s;
    font-size: 18px;
  }

  dl {
    margin-bottom: $margin-l;

    div {
      dt {
        color: $color-text-light;
      }

      dd {
        font-weight: bold;
        &.capitalize {
          text-transform: capitalize;
        }
      }
    }
  }
}
</style>
